import dayjs from 'dayjs';
import { useState } from 'react';

import { MinMaxStringValues } from '../../../../apis/graphql/types';
import { dateFormatLongYear, defaultDateFormatForBeServices } from '../../../../constants/dates';
import { formatDate } from '../../../../pages/Campaigns/utils';
import DateRange from '../../DateRange';
import { FilterFooter } from '../Footer/FilterFooter';
import { StyledInputWrapper, StyledText } from '../MinMaxFilter/styled';
import {
  StyledCalendarIcon,
  StyledDateFieldsWrapper,
  StyledDateInput,
  StyledEndDateInput,
  StyledErrorText,
} from './styled';
import { getDate, stringToDateFormat } from './utils';

type Props = {
  maxDate?: Date;
  additionalText?: string;
  choosenDateRange?: MinMaxStringValues;
  showError?: (dates: [Date | null, Date | null]) => string | null;
  onChange: (update?: MinMaxStringValues) => void;
  onClose: () => void;
};

const DateRangeFilterContent = ({
  maxDate,
  additionalText,
  showError,
  onChange,
  choosenDateRange,
  onClose,
}: Props): JSX.Element => {
  const [startDate, setStartDate] = useState(
    choosenDateRange?.min ? stringToDateFormat(choosenDateRange?.min, defaultDateFormatForBeServices) : null
  );
  const [endDate, setEndDate] = useState(
    choosenDateRange?.max ? stringToDateFormat(choosenDateRange?.max, defaultDateFormatForBeServices) : null
  );
  const [error, setIsError] = useState<string | null>(null);

  const handleOnDateRangeChange = (update: [Date | null, Date | null]): void => {
    setStartDate(update[0]);
    setEndDate(update[1]);
    if (showError) {
      setIsError(showError(update));
    }
  };

  const handleApplyFilter = (): void => {
    onChange({ min: formatDate(startDate) || null, max: endDate ? formatDate(endDate) : null });
  };

  return (
    <>
      <StyledDateFieldsWrapper>
        <StyledText>{additionalText} From</StyledText>
        <StyledText>To</StyledText>
        <StyledInputWrapper data-testid="startDateWrapper" $showCurrency={false}>
          <StyledDateInput
            data-testid="startDate"
            type="text"
            $error={Boolean(error)}
            defaultValue={choosenDateRange?.min ? dayjs(choosenDateRange?.min).format(dateFormatLongYear) : undefined}
            value={startDate ? getDate(startDate) : undefined}
          />
          <StyledCalendarIcon />
        </StyledInputWrapper>
        <StyledInputWrapper data-testid="endDateWrapper" $showCurrency={false}>
          <StyledEndDateInput
            type="text"
            $error={Boolean(error)}
            data-testid="endDate"
            defaultValue={choosenDateRange?.max ? dayjs(choosenDateRange?.max).format(dateFormatLongYear) : undefined}
            value={endDate ? getDate(endDate) : undefined}
          />
          <StyledCalendarIcon />
        </StyledInputWrapper>
      </StyledDateFieldsWrapper>
      {error && <StyledErrorText data-testid="errorMessageFilter">{error}</StyledErrorText>}
      <DateRange maxDate={maxDate} dateRange={[startDate, endDate]} onChange={handleOnDateRangeChange} />
      <FilterFooter isDisabled={Boolean(error)} handleApplyFilter={handleApplyFilter} handleCloseFilter={onClose} />
    </>
  );
};

export default DateRangeFilterContent;
